import React, { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/ordemCargaPage/actions';
import { Card, List } from 'antd';
import { RowLine, SpanBlock } from './styles';
import mask, { maskCurrency, maskUnd } from '../../../../../../utils/mask';
import CardSecMobile from '../CardSecMobile';
// import ModalCriarAgendamento from '../../../../components/ModalCriarAgendamento';

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  pagination,
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nuNota}>
            {/* <ModalCriarAgendamento /> */}
            <RowLine>
              <p>
                <strong>Ordem entrega</strong> <SpanBlock>{item.ordemCarga}</SpanBlock>
              </p>
              <p>
                <strong>Transportadora</strong> <SpanBlock>{item.nomeTransportadora}</SpanBlock>
              </p>
              <p>
                <strong>Tipo veículo</strong> <SpanBlock>{item.codTipoVeiculo}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Placa</strong> <SpanBlock>{item.placa}</SpanBlock>
              </p>
              <p>
                <strong>Nome do motorista</strong> <SpanBlock>{item.nomeParc}</SpanBlock>
              </p>
              <p>
                <strong>CPF</strong> <SpanBlock>{mask('cpfCnpj', item.cpf)}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Peso</strong> <SpanBlock>{maskUnd(item.pesoTotal) + ' KG'}</SpanBlock>
              </p>
              <p>
                <strong>Valor</strong> <SpanBlock>{maskCurrency(item.vlrTotal)}</SpanBlock>
              </p>
            </RowLine>
            <CardSecMobile ordemCarga={item.ordemCarga} cddAtivo={cddAtivo.codEmp} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
